import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const Singapore = () => {
    return <SharedDocumentsComponent permissionId="48" path="Singapura" />
}